var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParties = function SvgParties(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.541 8.998c1.122.842 2.125 2.96 2.125 4.266 0 .406-.295.736-.66.736h-.402m-4.25-8.451a2.44 2.44 0 0 0 1.214-2.112c0-.902-.488-1.69-1.214-2.11M2.327 14h11.631c.365 0 .66-.33.66-.736 0-2.557-2.127-4.63-6.475-4.63-4.349 0-6.477 2.073-6.477 4.63 0 .406.296.736.66.736M10.57 3.438a2.433 2.433 0 0 1-2.428 2.437 2.433 2.433 0 0 1-2.429-2.437A2.433 2.433 0 0 1 8.143 1a2.433 2.433 0 0 1 2.428 2.438"
  })));
};
export default SvgParties;